import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import ActiveAmbassadorsManagement from '@/components/admin/ActiveAmbassadorsManagement';
import AmbassadorApplicationsManagement from '@/components/admin/AmbassadorApplicationsManagement';

const AmbassadorsManagement = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-slate-900">Ambassadeurs</h2>
        <p className="mt-1 text-sm text-slate-500">
          Espace admin separe pour les ambassadeurs actifs et les candidatures en attente, sans melanger les vendeurs affilies.
        </p>
      </div>

      <Card className="border-slate-200">
        <CardHeader>
          <CardTitle>Perimetre admin ambassadeur</CardTitle>
          <CardDescription>
            Cette zone prepare la future evolution super ambassadeurs, sans activer de logique multi-niveaux maintenant.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-slate-600">
          Les candidatures, statuts, performances et commissions ambassadeur restent regroupes ici, tandis que les affiliations vendeur
          conservent leur propre espace admin.
        </CardContent>
      </Card>

      <Tabs defaultValue="active" className="space-y-6">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="active">Ambassadeurs actifs</TabsTrigger>
          <TabsTrigger value="applications">Candidatures</TabsTrigger>
        </TabsList>

        <TabsContent value="active">
          <ActiveAmbassadorsManagement />
        </TabsContent>

        <TabsContent value="applications">
          <AmbassadorApplicationsManagement embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AmbassadorsManagement;
